import { apiRequest } from '@/api/apiClient/base';
import type { SetupStatus } from '@/api/types';

/**
 * Whether this registrar still needs an admin to configure a GitHub token.
 * Public: unlike `getSettings` (admin-only), every visitor can read it, so a
 * signed-in non-admin also learns setup is pending rather than seeing a cryptic
 * load error.
 */
export function getSetupStatus(): Promise<SetupStatus> {
  return apiRequest<SetupStatus>('/api/setup');
}
